import { normalizeCanonicalPath } from './utils/url';

export const SITE_ORIGIN = 'https://atrivial.com';

/**
 * Builds an absolute Atrivial URL from an application path.
 * This stays deterministic across SSR and hydration.
 */
export function toAbsoluteSiteUrl(path: string): string {
  const normalizedPath = normalizeCanonicalPath(path.startsWith('/') ? path : `/${path}`);
  return `${SITE_ORIGIN}${normalizedPath}`;
}
